<template>
  <section class="section pt-5">
    <notes-datatable />
  </section>
</template>

<script>
import NotesDatatable from "./notes_datatable/Index.vue";

export default {
  name: "Notes",
  components: { NotesDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {},
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
